export enum ProductType {
    Club = 'club',
    Donation = 'donation',
    Payment = 'payment',
    Vpn = 'vpn',
    Course = 'course',
    PaperTurbo = 'paperturbo',
    Klu = 'klu',
}
